import axiosBase from "@/api/axiosBase";

const state = {
  resource: "",
  resourceHistory: "",
  storage: ""
}

const mutations = {

  setGetResource(state, data) {
    state.resource = data

    function formatDateTime(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    if (data.function && data.function.length > 0) {
      let functionData = data.function
      functionData.forEach((item, index) => {
        item.create_time = formatDateTime(item.create_time)
        item.update_time = formatDateTime(item.update_time)
        item.effective_time = formatDateTime(item.effective_time)
        item.expiration_time = formatDateTime(item.expiration_time)
      })
    }

    if (data.storage && data.storage.length > 0) {
      let storageData = data.storage
      storageData.forEach((item, index) => {
        item.create_time = formatDateTime(item.create_time)
        item.update_time = formatDateTime(item.update_time)
        item.effective_time = formatDateTime(item.effective_time)
        item.expiration_time = formatDateTime(item.expiration_time)
      })
    }

    if (data.time && data.time.length > 0) {
      let timeData = data.time
      timeData.forEach((item, index) => {
        item.create_time = formatDateTime(item.create_time)
        item.update_time = formatDateTime(item.update_time)
      })
    }
  },

  setGetResourceHistory(state, data) {
    state.resourceHistory = data

    function formatDateTime(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    if (data.storage && data.storage.length > 0) {
      let storageData = data.storage
      storageData.forEach((item, index) => {
        item.update_time = formatDateTime(item.update_time)
      })
    }


    if (data.time && data.time.length > 0) {
      let timeData = data.time
      timeData.forEach((item, index) => {
        item.update_time = formatDateTime(item.update_time)
      })
    }
  },

  setGetStorage(state, data) {
    let allFileData = data.file;
    let allModelData = data.model;
    allFileData.forEach((models, index) => {
      if (models.child.length > 0) {
        models.id = (index + 1)
        models.child.forEach((items, indexs) => {
          if (items.child.length > 0) {
            items.id = (index + 1) + "-" + (indexs + 1)
            items.child.forEach((itemss, indexss) => {
              if (itemss.child.length > 0) {
                itemss.id = (index + 1) + "-" + (indexs + 1) + "-" + (indexss + 1)
                itemss.child.forEach((itemsss, indexsss) => {
                  itemsss.id = (index + 1) + "-" + (indexs + 1) + "-" + (indexss + 1) + "-" + (indexsss + 1)
                })
              }
            })
          }
        })
      }
    })
    allModelData.forEach((models, index) => {
      if (models.child.length > 0) {
        models.id = (index + 1)
        models.child.forEach((items, indexs) => {
          if (items.child.length > 0) {
            items.id = (index + 1) + "-" + (indexs + 1)
            items.child.forEach((itemss, indexss) => {
              itemss.id = (index + 1) + "-" + (indexs + 1) + "-" + (indexss + 1)
            })

          }
        })
      }
    })
    state.storage = data
  },

}

const actions = {
  // 获取资源信息
  getResource({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/user/resource'
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        else {
          commit('setGetResource', res.data.data);
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取资源使用历史
  getResourceHistory({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/user/resource_history'
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        else {
          commit('setGetResourceHistory', res.data.data);
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },

  // 获取存储详情信息
  getStorage({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: 'GET',
        url: '/user/storage'
      }).then(res => {
        if (res.data.code != 200) {
          commit('message/setMessage', { 'type': 'error', 'message': res.data.msg }, { root: true });
        }
        else {
          commit('setGetStorage', res.data.data);
        }
        resolve(res)
      })
        .catch(error => {
          commit('message/setMessage', { 'type': 'error', 'message': error }, { root: true });
          resolve({ data: { code: 500 } })
        })
    })
  },
}

const getters = {
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}